export interface StudentReport {
  subjects: string[]
  results: {
    subject: string
    score: number
    grade: string
    term: string
  }[]
  teacherRemarks: string
  extracurriculars: string[]
}

export const studentReports: Record<string, StudentReport> = {
  "1": {
    subjects: ["Mathematics", "English Language", "Computer Science", "Physics", "Chemistry"],
    results: [
      { subject: "Mathematics", score: 92, grade: "A", term: "First Term" },
      { subject: "English Language", score: 88, grade: "A", term: "First Term" },
      { subject: "Computer Science", score: 95, grade: "A", term: "First Term" },
      { subject: "Physics", score: 90, grade: "A", term: "First Term" },
      { subject: "Chemistry", score: 87, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Emeka shows exceptional aptitude in STEM subjects and demonstrates strong problem-solving skills.",
    extracurriculars: ["Coding Club", "Robotics Team", "Math Olympiad"],
  },
  "2": {
    subjects: ["Biology", "Chemistry", "Physics", "Mathematics", "English Language"],
    results: [
      { subject: "Biology", score: 94, grade: "A", term: "First Term" },
      { subject: "Chemistry", score: 91, grade: "A", term: "First Term" },
      { subject: "Physics", score: 89, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 86, grade: "A", term: "First Term" },
      { subject: "English Language", score: 85, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Zainab displays outstanding dedication to the sciences with particular excellence in Biology.",
    extracurriculars: ["Science Club", "Health Awareness Club", "First Aid Team"],
  },
  "3": {
    subjects: ["Literature", "Government", "Economics", "English Language", "Civic Education"],
    results: [
      { subject: "Literature", score: 93, grade: "A", term: "First Term" },
      { subject: "Government", score: 90, grade: "A", term: "First Term" },
      { subject: "Economics", score: 88, grade: "A", term: "First Term" },
      { subject: "English Language", score: 92, grade: "A", term: "First Term" },
      { subject: "Civic Education", score: 89, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Chioma excels in humanities subjects and demonstrates excellent critical thinking abilities.",
    extracurriculars: ["Debate Club", "Literary Society", "Model UN"],
  },
  "4": {
    subjects: ["Technical Drawing", "Mathematics", "Physics", "Computer Science", "Further Mathematics"],
    results: [
      { subject: "Technical Drawing", score: 96, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 94, grade: "A", term: "First Term" },
      { subject: "Physics", score: 92, grade: "A", term: "First Term" },
      { subject: "Computer Science", score: 91, grade: "A", term: "First Term" },
      { subject: "Further Mathematics", score: 93, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Tunde shows exceptional talent in design and spatial reasoning, ideal for Architecture studies.",
    extracurriculars: ["Art & Design Club", "Architecture Workshop", "3D Modeling Team"],
  },
  "5": {
    subjects: ["English Language", "Literature", "Mathematics", "Social Studies", "Civic Education"],
    results: [
      { subject: "English Language", score: 88, grade: "A", term: "First Term" },
      { subject: "Literature", score: 90, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 85, grade: "A", term: "First Term" },
      { subject: "Social Studies", score: 87, grade: "A", term: "First Term" },
      { subject: "Civic Education", score: 86, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Fatima is a natural educator with excellent communication skills and patience.",
    extracurriculars: ["Peer Tutoring", "Library Volunteer", "Reading Club"],
  },
  "6": {
    subjects: ["Physics", "Chemistry", "Further Mathematics", "Technical Drawing", "Computer Science"],
    results: [
      { subject: "Physics", score: 95, grade: "A", term: "First Term" },
      { subject: "Chemistry", score: 91, grade: "A", term: "First Term" },
      { subject: "Further Mathematics", score: 93, grade: "A", term: "First Term" },
      { subject: "Technical Drawing", score: 90, grade: "A", term: "First Term" },
      { subject: "Computer Science", score: 89, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Chukwudi demonstrates strong engineering aptitude with excellent practical skills.",
    extracurriculars: ["Engineering Club", "Science Fair", "Innovation Lab"],
  },
  "7": {
    subjects: ["Economics", "Commerce", "Accounting", "Business Studies", "Mathematics"],
    results: [
      { subject: "Economics", score: 91, grade: "A", term: "First Term" },
      { subject: "Commerce", score: 89, grade: "A", term: "First Term" },
      { subject: "Accounting", score: 90, grade: "A", term: "First Term" },
      { subject: "Business Studies", score: 88, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 87, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Blessing shows strong business acumen and analytical skills in commercial subjects.",
    extracurriculars: ["Young Entrepreneurs Club", "Business Plan Competition", "Finance Society"],
  },
  "8": {
    subjects: ["Agricultural Science", "Biology", "Chemistry", "Geography", "Mathematics"],
    results: [
      { subject: "Agricultural Science", score: 92, grade: "A", term: "First Term" },
      { subject: "Biology", score: 88, grade: "A", term: "First Term" },
      { subject: "Chemistry", score: 85, grade: "A", term: "First Term" },
      { subject: "Geography", score: 87, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 84, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Ibrahim displays excellent understanding of agricultural sciences and environmental studies.",
    extracurriculars: ["School Farm", "Environmental Club", "Agriculture Society"],
  },
  "9": {
    subjects: ["Fine Arts", "Literature", "Graphic Design", "Art History", "English Language"],
    results: [
      { subject: "Fine Arts", score: 95, grade: "A", term: "First Term" },
      { subject: "Literature", score: 90, grade: "A", term: "First Term" },
      { subject: "Graphic Design", score: 93, grade: "A", term: "First Term" },
      { subject: "Art History", score: 89, grade: "A", term: "First Term" },
      { subject: "English Language", score: 88, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Ngozi possesses exceptional artistic talent with a unique creative vision.",
    extracurriculars: ["Art Club", "Drama Society", "Design Workshop"],
  },
  "10": {
    subjects: ["Accounting", "Economics", "Commerce", "Mathematics", "Business Studies"],
    results: [
      { subject: "Accounting", score: 94, grade: "A", term: "First Term" },
      { subject: "Economics", score: 91, grade: "A", term: "First Term" },
      { subject: "Commerce", score: 90, grade: "A", term: "First Term" },
      { subject: "Mathematics", score: 92, grade: "A", term: "First Term" },
      { subject: "Business Studies", score: 89, grade: "A", term: "First Term" },
    ],
    teacherRemarks: "Oluwaseun demonstrates excellent numerical skills and attention to detail in accounting.",
    extracurriculars: ["Accounting Club", "Finance Society", "Business Mathematics Team"],
  },
}
